/**
 * Administration screens (lazy chunks; the dnd-kit template builder lives only here).
 * Owned by the "admin screens" work stream — only this file changes for their routes.
 */
import type { RouteObject } from '../lib/router';
import { lazyPage } from './lazy';

const shared = () => import('../features/admin/shared');
const users = () => import('../features/admin/UsersPage');
const templates = () => import('../features/admin/templates/TemplatesPage');
const builder = () => import('../features/admin/templates/BuilderPage');
const customers = () => import('../features/admin/CustomersPage');
const sites = () => import('../features/admin/SiteAdminPages');

export const ADMIN_ROUTES: RouteObject[] = [
  { path: '/admin', element: lazyPage(shared, 'AdminHomePage') },
  { path: '/admin/users', element: lazyPage(users, 'UsersPage') },
  { path: '/admin/users/:id', element: lazyPage(users, 'UserDetailPage') },
  { path: '/admin/customers', element: lazyPage(customers, 'CustomersPage') },
  { path: '/admin/customers/:id', element: lazyPage(customers, 'CustomerEditPage') },
  { path: '/admin/sites', element: lazyPage(sites, 'SitesAdminPage') },
  { path: '/admin/sites/:id', element: lazyPage(sites, 'SiteEditPage') },
  { path: '/admin/sites/:id/tags', element: lazyPage(() => import('../features/checkpoints/SiteTagsPage'), 'SiteTagsPage') },
  { path: '/admin/roles', element: lazyPage(() => import('../features/admin/RolesPage'), 'RolesPage') },
  { path: '/admin/org', element: lazyPage(() => import('../features/admin/OrgPage'), 'OrgPage') },
  { path: '/admin/catalogue', element: lazyPage(() => import('../features/catalogue/CataloguePage'), 'CataloguePage') },
  { path: '/admin/intel', element: lazyPage(() => import('../features/intel/IntelPage'), 'IntelPage') },
  { path: '/admin/settings', element: lazyPage(() => import('../features/admin/SettingsPage'), 'SettingsPage') },
  { path: '/admin/legal-texts', element: lazyPage(() => import('../features/admin/LegalTextsPage'), 'LegalTextsPage') },
  { path: '/admin/legal-holds', element: lazyPage(() => import('../features/retention/LegalHoldsPage'), 'LegalHoldsPage') },
  { path: '/admin/imports', element: lazyPage(() => import('../features/admin/ImportsPage'), 'ImportsPage') },
  { path: '/admin/templates', element: lazyPage(templates, 'TemplatesPage') },
  { path: '/admin/templates/:id', element: lazyPage(builder, 'TemplateBuilderPage') },
  { path: '/admin/api-clients', element: lazyPage(() => import('../features/admin/ApiClientsPage'), 'ApiClientsPage') },
  { path: '/admin/audit', element: lazyPage(() => import('../features/admin/AuditPage'), 'AuditPage') },
];
